module.exports = __webpack_public_path__ + "static/media/Plymouth-Village-Condominium-Master-Deed.5791be4b.pdf";